import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppMainComponent } from './menu/app.main.component';

import { canActivateGuard } from './guards/auth.guard';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { LoginComponent } from './components/auth/login/login.component';
import { HelperViewClientsComponent } from './modules/help/components/helper-view-clients/helper-view-clients.component';
import { AppDownloadComponent } from './modules/appdownload/appdownload.component';
import { BusCalculationComponent } from './modules/bus-calculation/bus-calculation.component';
import { PasswordUpdateComponent } from './modules/password-update/password-update.component';
import { GreenPower3Component } from './modules/greenpower3/green-power3.component';
import { ListDeviceSupportComponentNoAuthComponent } from './modules/list-device-support/list-device-support-no-auth/list-device-support-no-auth.component';
import { PublicFwPageNoAuthComponent } from './modules/public-fw-page-noauth/public-fw-page-noauth.component';
import { PageWorkInProgressComponent } from './components/page-work-in-progress/page-work-in-progress.component';
import { PublicSwPageNoAuthComponent } from './modules/public-sw-page-noauth/public-sw-page-noauth.component';

const routes: Routes = [

	{
		path: '',
		component: AppMainComponent,
		pathMatch: 'full',
		canActivate: [canActivateGuard],
		children: [
		],
	},
	{ path: 'login', component: LoginComponent },
	{ path: 'tools/accessories/helper', component: HelperViewClientsComponent },
	{ path: 'tools/accessories/busCalculation', component: BusCalculationComponent },
	{ path: 'tools/accessories/greenPower', component: GreenPower3Component },
	{ path: 'tools/accessories/supportDevice', component: ListDeviceSupportComponentNoAuthComponent },
	{ path: 'tools/accessories/firmwareList', component: PublicFwPageNoAuthComponent },
	{
		path: 'public',
		loadChildren: () => import('./modules/public-releases-noauth/public-releases-noauth.module')
			.then(m => m.PublicReleasesNoAuthModule),
	},
	{ path: 'tools/accessories/softwareList', component: PublicSwPageNoAuthComponent },
	{ path: 'tools/accessories/appdownload', component: AppDownloadComponent },
	{ path: 'pwd/update', component: PasswordUpdateComponent },
	{ path: '', loadChildren: () => import('./components/registration/registration.module').then(m => m.RegistrationModule) },
	{ path: '', loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule) },
	{ path: '', loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule), data: { preload: true } },
	{ path: '', loadChildren: () => import('./components/impers/impers.module').then(m => m.ImpersModule), data: { preload: true } },
	{ path: '', loadChildren: () => import('./components/draft/draft.module').then(m => m.DraftModule), data: { preload: true } },
	{ path: '', loadChildren: () => import('./components/technician/technician.module').then(m => m.TechnicianModule), data: { preload: true } },
	{ path: '', loadChildren: () => import('./components/privacy/privacy.module').then(m => m.PrivacyModule), data: { preload: true } },
	{ path: '', loadChildren: () => import('./components/came-service/came-service.module').then(m => m.CameServiceModule) },
	{ path: '', loadChildren: () => import('./components/came-subsidiary/came-subsidiary.module').then(m => m.CameSubsidiaryModule) },
	{ path: '', loadChildren: () => import('./components/came-marketing/came-marketing.module').then(m => m.CameMarketingModule) },
	// Area ruolo FIRM_TECH: shell + pagina /firm-tech/software-updates.
	{ path: '', loadChildren: () => import('./components/came-firm-tech/firm-tech.module').then(m => m.FirmTechModule) },
	{ path: '', loadChildren: () => import('./components/access/access.module').then(m => m.AccessModule) },
	{ path: '', loadChildren: () => import('./modules/email-unsubscribe/email-unsubscribe.module').then(m => m.EmailUnsubscribeModule) },
	{ path: 'wip', component: PageWorkInProgressComponent },
	{ path: 'notfound', component: PageNotFoundComponent },
	{ path: '**', redirectTo: '/notfound' },
];

@NgModule({
	imports: [
		RouterModule.forRoot(
			routes,
			{
				scrollPositionRestoration: 'enabled',
				anchorScrolling: 'enabled',
				onSameUrlNavigation: 'reload',
				useHash: false,            // Adds the '#' character to separate URL. The part afterthe # is never sent to server. So tomcat will not get the entire path
			}
		),
	],
	exports: [RouterModule],
})
export class AppRoutingModule { }
